import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Redux
import { connect } from 'react-redux';
import { Field, change } from 'redux-form';
// Compose
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
import {
  Button,
  FormGroup,
  FormControl,
} from 'react-bootstrap';
import Loader from '../Loader';
import AvailableDates from './AvailableDates';
import DateRange from './DateRange';
import messages from '../../locale/jsonMessages';
import { getListingDataStep3 } from '../../actions/getListingDataStep3';
import { getListBlockedDates } from '../../actions/Listing/getListBlockedDates';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { withMutation } from '../../hoc/withGraphql';
//Image
import closeIcon from '/public/SiteIcons/saveCalenderClose.svg';

import cs from '../commonStyle.css';
import c from './SaveCalendar.css';
class SaveCalendar extends Component {

  static propTypes = {
    change: PropTypes.func,
    formName: PropTypes.string,
    selectedDays: PropTypes.array,
    start: PropTypes.any,
    end: PropTypes.any
  };

  static defaultProps = {
    selectedDays: [],
    start: undefined,
    end: undefined,
    formName: 'ListPlaceStep3',
    formNameValue: 'CalendarPrice',
    isCurrentStatus: 2,
  };

  constructor(props) {
    super(props);
    this.state = {
      dateRange: [],
      isLoading: false,
      isCurrentStatus: 2
    };
    this.chooseDates = this.chooseDates.bind(this);
  }

  componentDidMount() {
    this.setState({ isCurrentStatus: 2 });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { start, end } = nextProps;
    let dateRange = [], rangeStart, rangeEnd;
    if (start && !end) {
      rangeStart = new Date(start);
      dateRange.push(rangeStart);
    } else if (start && end) {
      rangeStart = new Date(start);
      rangeEnd = new Date(end);
      if (!moment(rangeStart).isSame(rangeEnd)) {
        dateRange.push(rangeStart);
        rangeStart = new Date(+rangeStart);
        while (rangeStart < end) {
          dateRange.push(rangeStart);
          var newDate = rangeStart.setDate(rangeStart.getDate() + 1);
          rangeStart = new Date(newDate);
        }
      } else {
        dateRange.push(rangeStart);
      }
    }
    this.setState({ dateRange });
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {touched && error && <span className={c.errorMessage}>{formatMessage(error)}</span>}
        <FormControl
          {...input}
          placeholder={label}
          type={type}
          className={className}
          maxLength={3}
        />
      </div>
    )
  }

  renderDateRange = ({ input, label, meta: { touched, error }, formName, numberOfMonths, startDateName, endDateName, index, defaultStartDate, defaultEndDate, isCurrentStatus, resetCalendar }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx('specialPriceCalendar')}>
        {touched && error && <span className={c.errorMessage}>{formatMessage(error)}</span>}
        <DateRange
          {...input}
          formName={formName}
          numberOfMonths={numberOfMonths}
          index={index}
          defaultStartDate={defaultStartDate}
          defaultEndDate={defaultEndDate}
          isCurrentStatus={isCurrentStatus}
          resetCalendar={resetCalendar}
        />
      </div>
    )
  }

  async handleSave() {
    const { change, selectedDays, setStateLoading } = this.props;
    const { resetCalendar, mutate, listId, getListingDataStep3, getListBlockedDates } = this.props;
    const { formatMessage } = this.props.intl;
    const { minDay, maxDay, houseRules, checkInEnd, checkInStart } = this.props;
    const { cancellationPolicy, maxDaysNotice, bookingNoticeTime } = this.props;
    const { basePrice, currency, isStartDate, isEndDate, monthlyDiscount, weeklyDiscount, securityDeposit } = this.props;

    let minDayValues = minDay != '' ? minDay : 0;
    let maxDayValues = maxDay != '' ? maxDay : 0;
    let checkInEndValue = checkInEnd != '' ? checkInEnd : 'flexible';
    let checkInStartValue = checkInStart != '' ? checkInStart : 'flexible';
    let isCancel = cancellationPolicy ? cancellationPolicy : '1';
    let isMaxDays = maxDaysNotice ? maxDaysNotice : 'unavailable';
    let isBooking = bookingNoticeTime ? bookingNoticeTime : 58;
    let updatedSelectedDays = selectedDays;
    let errorMsg = formatMessage(messages.selectedDatesError);

    let dateRangeNew = [], rangeStart, rangeEnd;
    if (isStartDate && !isEndDate) {
      rangeStart = new Date(isStartDate);
      dateRangeNew.push(rangeStart);
    } else if (isStartDate && isEndDate) {
      rangeStart = new Date(isStartDate);
      rangeEnd = new Date(isEndDate);
      if (!moment(rangeStart).isSame(rangeEnd)) {
        dateRangeNew.push(rangeStart);
        rangeStart = new Date(+rangeStart);
        while (rangeStart < isEndDate) {
          dateRangeNew.push(rangeStart);
          var newDate = rangeStart.setDate(rangeStart.getDate() + 1);
          rangeStart = new Date(newDate);
        }
      } else {
        dateRangeNew.push(rangeStart);
      }
    }
    setStateLoading({ isSaving: true });

    if (dateRangeNew && dateRangeNew.length > 0) {
      dateRangeNew.forEach(async (item, index) => {
        let selectedIndex = updatedSelectedDays.findIndex(selectedDay =>
          moment(selectedDay).isSame(item)
        );
        if (selectedIndex < 0) {
          updatedSelectedDays.push(item);
        }
      });
      const { data } = await mutate({
        variables: {
          listId,
          blockedDates: updatedSelectedDays,
          calendarStatus: 'blocked'
        }
      })
      if (data && data.UpdateBlockedDates && data.UpdateBlockedDates.status == '200') {
        await change("blockedDates", updatedSelectedDays);
        await getListingDataStep3(listId);
        await getListBlockedDates(
          listId,
          minDayValues,
          maxDayValues,
          checkInEndValue,
          checkInStartValue,
          houseRules,
          isCancel,
          isMaxDays,
          isBooking,
          basePrice,
          currency,
          monthlyDiscount,
          weeklyDiscount,
          securityDeposit
        );
        await getListingDataStep3(listId);
      } else if (data?.UpdateBlockedDates?.status == '400') {
        showToaster({ messageId: 'updateBlockedDates', toasterType: 'error' })
      } else {
        showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: errorMsg })
      }
      await resetCalendar();
    }

    clearTimeout(this.loadSync);
    this.loadSync = null;
    this.loadSync = setTimeout(() => {
      setStateLoading({ isSaving: false });
    }, 1000);

  }

  chooseDates(e) {
    this.setState({ isCurrentStatus: e });
  }


  render() {
    const { selectedDays, start, end, formName, resetCalendar, listId, resetDatePickerChange } = this.props;
    const { formatMessage } = this.props.intl;
    const { minDay, maxDay, houseRules, checkInEnd, checkInStart } = this.props;
    const { cancellationPolicy, maxDaysNotice, bookingNoticeTime, isStartDate, isEndDate } = this.props;
    const { basePrice, currency, monthlyDiscount, weeklyDiscount, isSaving, setStateLoading, isBlocking, securityDeposit } = this.props;
    const { isCurrentStatus } = this.state;

    const { dateRange, isLoading } = this.state;
    let isBlock = 1, isAvailable = 2;

    return (
      <div>
        {
          (start || isStartDate) &&
          <div className={cx(c.saveCalendarContainer, c.CalendarPopup)}>
            <div className={c.innerCPopup}>
              <FormGroup className={cx(c.textRight, cs.spaceBottom4)}>
                <Button bsStyle="link"
                  className={cx(c.noPadding)}
                  onClick={() => { resetCalendar() }}>
                  <img src={closeIcon} />
                </Button>
              </FormGroup>
              <div className="oneColumnGrid">
                <div className={c.aBlockWrap}>
                  <div className={c.aBWLeft}>
                    <Button
                      className={cx(c.btnBg, { [c.active]: isCurrentStatus == 2 })}
                      onClick={() => this.chooseDates(isAvailable)}
                    >
                      <FormattedMessage {...messages.available} />
                    </Button>
                  </div>
                  <div className={c.aBWRight}>
                    <Button
                      className={cx(c.btnBg, { [c.active]: isCurrentStatus == 1 })}
                      onClick={() => this.chooseDates(isBlock)}
                    >
                      <FormattedMessage {...messages.block} />
                    </Button>
                  </div>
                </div>

                <FormGroup className={cs.noMargin}>
                  <label className='commonLabelText'>
                    <FormattedMessage {...messages.selectedDates} />
                  </label>
                  <Field
                    name="blockedDates"
                    component={this.renderDateRange}
                    defaultStartDate={start}
                    defaultEndDate={end}
                    formName={formName}
                    isCurrentStatus={isCurrentStatus}
                    resetCalendar={resetDatePickerChange}
                  />
                </FormGroup>

                {isCurrentStatus == 1 &&
                  <div className='doubleBtnFlexEnd'>
                    <Button
                      disabled={isSaving || isBlocking}
                      className={cs.btnPrimaryBorder}
                      onClick={() => { resetCalendar() }}
                    >
                      <FormattedMessage {...messages.deSelect} />
                    </Button>

                    <Loader
                      type={"button"}
                      buttonType={"button"}
                      show={isSaving}
                      className={cx(cs.btnPrimary, 'loaderButtonFlex')}
                      disabled={isSaving || isBlocking}
                      label={formatMessage(messages.blockedDates)}
                      handleClick={() => { this.handleSave() }}
                      containerClass={c.loaderContainer}
                    />
                  </div>
                }

                {
                  isCurrentStatus == 2 && <AvailableDates
                    start={start}
                    end={end}
                    listId={listId}
                    selectedDays={selectedDays}
                    resetCalendar={resetCalendar}
                    dateRange={dateRange}
                    minDay={minDay}
                    maxDay={maxDay}
                    houseRules={houseRules}
                    checkInEnd={checkInEnd}
                    checkInStart={checkInStart}
                    cancellationPolicy={cancellationPolicy}
                    maxDaysNotice={maxDaysNotice}
                    bookingNoticeTime={bookingNoticeTime}
                    basePrice={basePrice}
                    currency={currency}
                    isStartDate={isStartDate}
                    isEndDate={isEndDate}
                    weeklyDiscount={weeklyDiscount}
                    monthlyDiscount={monthlyDiscount}
                    setStateLoading={setStateLoading}
                    isBlocking={isBlocking}
                    isSaving={isSaving}
                    securityDeposit={securityDeposit}
                  />
                }
              </div>
            </div>
          </div>

        }
      </div>
    );
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  change,
  getListingDataStep3,
  getListBlockedDates
};

export default compose(
  injectIntl,
  withStyles(cs, c),
  connect(mapState, mapDispatch),
  withMutation(gql`
    mutation (
      $listId: Int!, 
      $blockedDates: [String],
      $calendarStatus: String
    ) {
          UpdateBlockedDates (
            listId: $listId, 
            blockedDates: $blockedDates,
            calendarStatus: $calendarStatus
        ) {
          status
        }
        }
  `)
)(SaveCalendar);
